module.exports = __webpack_public_path__ + "img/bohui_active.052234c0.png";